import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    console.log("SearchFormController connected");
  }

  submit() {
    console.log("Search form submitted");
    this.element.requestSubmit()
  }

  refocus(event) {
    console.log("Refocusing search input");
    this.inputTarget.focus();
  }
}
